import { render, staticRenderFns } from "./showArt.vue?vue&type=template&id=5dc4dec1&scoped=true&"
import script from "./showArt.vue?vue&type=script&lang=js&"
export * from "./showArt.vue?vue&type=script&lang=js&"
import style0 from "./showArt.vue?vue&type=style&index=0&id=5dc4dec1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc4dec1",
  null
  
)

export default component.exports